import React from "react";
import OnlyInvoieToPrint from "./onlyInvoiceToPrint";

import ReactToPrint from "react-to-print";
import { Printer } from "react-feather";

class PrintableInvoice extends React.PureComponent {
  render() {
    return (
      <div>
        <OnlyInvoieToPrint />
      </div>
    );
  }
}

class Print extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="zp-inv-toolbar">
          <ReactToPrint
            trigger={() => {
              return (
                <button type="button" className="zp-inv-print-btn">
                  <Printer size={16} aria-hidden="true" />
                  Print invoice
                </button>
              );
            }}
            content={() => this.componentRef}
          />
        </div>
        <PrintableInvoice
          ref={(el) => (this.componentRef = el)}
          orderObj={this.props.orderObj}
        />
      </div>
    );
  }
}

export default Print;
